import { getUniqueCode } from '../../../../utils/getUniqueCode.ts';
import { sanitizeCode } from '../../../../utils/sanitizeCode.ts';
import { type IMapLayer } from './MapLayer.ts';

/**
 * Deriva il code "base" di un layer (prima della deduplicazione): usa il code
 * esistente se presente, altrimenti lo ricava dal nome (fallback `'layer'`).
 */
export function getLayerCodeBase(
  layer: Pick<IMapLayer, 'code' | 'name'>,
): string {
  return layer.code || sanitizeCode(layer.name) || 'layer';
}

/**
 * Assegna a `layer` un `code` valido e univoco rispetto a `usedCodes`.
 *
 * Parte dal code base ({@link getLayerCodeBase}) e lo rende univoco. Il code
 * scelto viene aggiunto a `usedCodes` (mutazione) così da poter processare più
 * layer in sequenza. Ritorna lo stesso riferimento se il code non cambia,
 * altrimenti una copia.
 */
export function assignUniqueLayerCode(
  layer: IMapLayer,
  usedCodes: Set<string>,
): IMapLayer {
  const code = getUniqueCode(getLayerCodeBase(layer), usedCodes);
  usedCodes.add(code);
  return code === layer.code ? layer : { ...layer, code };
}
